import {
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { actions } from "../../redux/actions/menuOption";

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: "none",
    "&:hover": {
      backgroundColor: "white !important",
      color: "black",
      cursor: "pointer",
    },
  },
}));
const MenuOption = ({
  name,
  url,
  icon,
  idOption,
  showExpandIcon,
  changeIcon,
  selectMenuOption,
  menuOption: { optionSelected },
}) => {
  const classes = useStyles();

  const handleSubmenuOptions = () => {
    if (idOption !== undefined) selectMenuOption({ optionSelected: idOption });
    if (showExpandIcon) {
      if (name === "Inventario") changeIcon(0);
      else if (name === "Ventas") changeIcon(1);
      else if (name === "Inventarios") changeIcon(2);
      else if (name === "Ventas.") changeIcon(3);
    }
  };

  return (
    <>
      {url ? (
        <Link to={url} className={classes.link}>
        <ListItem
          button
          selected={idOption !== undefined && optionSelected === idOption}
          onClick={handleSubmenuOptions}
        >
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText
            primary={
              <Typography
                type="body"
                style={{ color: "#ffff", fontWeight: "bold" }}
              >
                {name}
              </Typography>
            }
          />
          {showExpandIcon}
        </ListItem>
      </Link>
      ): (
        <ListItem
        button
        selected={idOption !== undefined && optionSelected === idOption}
        onClick={handleSubmenuOptions}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText
          primary={
            <Typography
              type="body"
              style={{ color: "#ffff", fontWeight: "bold" }}
            >
              {name}
            </Typography>
          }
        />
        {showExpandIcon}
      </ListItem>
      )}
    </>
    
  );
};

const mapStateToProps = (state) => ({
  menuOption: state.menuOption,
});

const dispatch = {
  selectMenuOption: actions.selectMenuOption,
};

export default connect(mapStateToProps, dispatch)(MenuOption);
